export default "__VITE_ASSET__Cjd212Zi__"